export default __webpack_public_path__ + "f03e172ff0910a8919823d06ab51c529.svg";